export default {
  /**
   * Set the List items
   *
   * @param state
   * @param items
   */
  setStaffArchivedList(state, items) {
    state.items = items;
  },

  /**
   * Set List pagination meta
   *
   * @param state
   * @param pagination
   */
  setStaffArchivedListPagination(state, pagination) {
    state.pagination = pagination;
  },

  /**
   * Set List current page
   *
   * @param state
   * @param currentPage
   */
  setStaffArchivedListPage(state, currentPage) {
    state.pagination.current_page = currentPage;
  },

  /**
   *
   * @param state
   * @param filters
   */
  setStaffArchivedListFilters(state, filters) {
    console.log("Filters : ", filters);

    state.filters = filters;
  },

  /**
   *
   * @param state
   * @param isBusy
   */
  setStaffArchivedListBusy(state, isBusy) {
    console.log("Busy : ", isBusy);
    state.isBusy = isBusy;
  },
};
